/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".fixedHeight_4bef984a{height:300px}"}]);
export const fixedHeight = "fixedHeight_4bef984a";